import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import Hint from 'src/ui/atoms/hint';
import useApiCall from 'src/hooks/use-api-call';
import { AdminApi } from 'src/api';

export interface DeleteGroupUserConfirmationModalProps {
  onDelete: () => void;
  onClose: () => void;
  groupName: string;
  groupId: string;
  email: string;
  userId: string;
}

const DeleteGroupUserConfirmationModal: FunctionComponent<DeleteGroupUserConfirmationModalProps> = (props) => {
  const { onDelete, onClose, groupName, groupId, email, userId } = props;
  const { makeAuthenticatedApi, withApi } = useApiCall();
  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const removeGroupUser = useCallback(() => {
    withApi(async () => {
      await adminApi.adminGroupsUsersDestroy({ id: groupId, userId });
      onDelete();
    });
  }, [withApi, adminApi, groupId, userId]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="confirmDeleteGroupUserModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate
          name="confirmDeleteGroupUserModal.content"
          args={[<strong>{email}</strong>, <strong>{groupName}</strong>]}
        />
        <Hint variant="warning">
          <Translate name="confirmDeleteGroupUserModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              onClick: onClose,
            },
            {
              name: 'delete',
              content: <Translate name="common.remove" />,
              variant: 'primary',
              type: 'submit',
              size: 'large',
              onClick: removeGroupUser,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteGroupUserConfirmationModal;
